// Strings for "link this barcode to an existing item" (kitchen flow, Stage 2D).
export const BL = {
  title: 'Link this barcode',
  help: (code: string) => `No item has barcode ${code} yet. Pick the item it belongs to — the scan then carries on.`,
  search: 'Search items…',
  noMatch: 'No items match.',
  perScan: 'Each scan counts as',
  one: (unit: string) => `1 ${unit}`,
  purchase: (label: string, factor: string, unit: string) => `1 ${label} (${factor} ${unit})`,
  other: 'Other amount',
  save: 'Link and carry on',
  saving: 'Linking…',
  cancel: 'Not now',
  linked: (name: string) => `Linked to ${name}`,
  unknownNoRights: (code: string) => `Barcode ${code} is not linked to any item — ask the store to link it.`,
  change: 'Change item',
} as const
